/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useCallback,useState,useEffect} from 'react'
import { connect } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

import EmptyPage from '../../Components/EmptyPage'
import Pagination from '../../Components/Pagination';
import { DistributorActions } from '../../redux/actions';
import { WishlistedProduct } from '../../redux/helper/AddWishlist';
import { FilterPayloadConstruction } from '../../redux/helper/FIlterPayloadConstructor';
import { distributorService } from '../../service/distributor.service';
import ProductList from './ProductList';
import ProductListSkeleton from './ProductListSkeleton';
import './style.css'
function ManageProducts({GetProductList,Products,FilterData,handleSegments,GetCartItems,Cart,handleFiltersData}) {
    const [InitialLoad, setInitialLoad] = useState(true);
    const [Segments, setSegments] = useState([])
    const [Filters, setFilters] = useState({});
    const [checkBox, setcheckBox] = useState([]);
    const [filterLoader, setFilterLoader] = useState(false);
    const [uniqCount, setuniqCount] = useState({});
    const [mainCategories, setmainCategories] = useState([])
    const [resposivePopup, setresposivePopup] = useState(false);
    const [result, setresult] = useState([])
    const [sizeList, setSizeList] = useState([]);
    const [lengthList, setLengthList] = useState([]);
    const [filterParam, setFilterParam] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [priceError, setPriceError] = useState(false);
    let current = 1
    let price = {
        minValue:0,
        maxValue:0
    }
    const [toggles, settoggles] = useState({
        sort: false,
    })
    const location= useLocation()
    const searchP = new URLSearchParams(location.search)
    let diameter = ''
    let length = ''
    const initialState={
        "page":1,
        "limit":10,
    }
    if (searchP.get('category')){
        initialState.category=[...searchP.getAll('category')]
    }
    if (searchP.get('DIAMETER')){
        initialState.DIAMETER=searchP.get('DIAMETER')
        diameter = searchP.get('DIAMETER')
    }
    if (searchP.get('LENGTH')){
        initialState.LENGTH=searchP.get('LENGTH')
        length = searchP.get('DIAMLENGTHETER')
    }
    if (searchP.get('PRICE_RANGE')){
        initialState.PRICE_RANGE=[...searchP.getAll('PRICE_RANGE')]
        price = {
            minValue:initialState.PRICE_RANGE[0],
            maxValue:initialState.PRICE_RANGE[1]
        }
    }
    if (searchP.get('page')){
        initialState.page=searchP.get('page')
        current = parseInt(searchP.get('page'))
        // setcurrentPage(parseInt(searchP.get('page')))
    }
    const [priceRange, setpriceRange] = useState(price)
    const [Size, setSize] = useState({
        LENGTH:diameter,
        DIAMETER:length
    })
    const [currentPage, setcurrentPage] = useState(current);
    const [payload, setpayload] = useState(initialState);
    const [wishlistProduct, setwishlistProduct] = useState([])
    const handleFetch = useCallback((async() => {
        settoggles((state)=>({
            ...state,
            sort:false
        }))
        if(!payload.search){
            // setInitialLoad(true)
        }
        GetProductList(payload)
        const listwish= await WishlistedProduct();
        setwishlistProduct(listwish)
        GetCartItems()
        setTimeout(() => {
            window.scrollTo(0, 0)
            setInitialLoad(false)
        }, 2000);   
        setresposivePopup(false)     
    }), [payload]);
    useEffect(() => {
        if(Object.keys(FilterData).length>0){
            setSegments(FilterData.filters)
        }
    }, [FilterData])
    const iterate = useCallback(
        (obj) => {
            for (var property in obj) {   
                if (obj.hasOwnProperty(property)) {
                    if (Object.keys(obj[property]).length > 0 && property!=="" && property!=='concatenated_segment') {
                        obj[property].concatenated_segment = obj.concatenated_segment?
                            `${obj.concatenated_segment}.${property}`:property;

                        iterate(obj[property]);
                    }else{
                        if(property!=='concatenated_segment')
                            obj[property].concatenated_segment = `${obj.concatenated_segment}.${property}`
                    }
                }
            }
            return obj        
        },
        [],
    )
    function transform(object,newid,id1) {
        if(Object.keys(object).length>0){
            return Object
                .entries(object).filter(([keyVal, value])=>value!=='' && keyVal!=='')
                .map(([name, value]) => {
                    if (value.hasOwnProperty('')) {
                        Object.keys(value).map((key) => key === '' && delete value[key]);
                    }
                    if (value !== '') {
                        const con = {
                            name,
                            ...(value && typeof value === 'object' && !value.hasOwnProperty('')
                                ? {
                                    newid: `${id1++}-${name}`,
                                    id: `${newid === '' ? '' : `${newid}.`}${name}`,
                                    items: transform(value, `${newid === '' ? '' : `${newid}.`}${name}`, Object.keys(object).length),
                                }
                                : { newid: `${id1++}-${name}`, id: `${newid === '' ? '' : `${newid}.`}${name}` }),
                        };
                        if(payload.category){
                            payload.category.forEach((element) => {
                                if ((con.id.includes(element) || element.includes(con.id)) && !con.hasOwnProperty('status')) {
                                    con.status = 1;
                                }
                            });
                        }
                        return con;
                    }
                });
        }
    }
    
    const handleFetchFilters = useCallback((() => {
        distributorService.GetProductsFiters().then((res)=>{
            if(res.data.success_status){
                const data=transform(res.data.data,'',1);
                setresult(data)
                const lengthFilter = res.data.filter_length.filter(({ LENGTH }) => LENGTH !== null && !isNaN(LENGTH))
                const sizeFilter = res.data.filter_size.filter(({ DIAMETER }) => DIAMETER !== null && !isNaN(DIAMETER))
                setLengthList(lengthFilter);
                setSizeList(sizeFilter);
                setFilterParam({DIAMETER:sizeFilter,LENGTH:lengthFilter})
                setmainCategories(Object.keys((res.data.data)))
            }
            setFilterLoader(true);
        })       
    }), []);
    
    useEffect(() => {
        handleFetch();
    }, [handleFetch]);
    useEffect(() => {
        handleFetchFilters();
    }, []);
    const handlePageClick =(data) => {
        // setInitialLoad(true);
        const page = data.selected + 1;
        setcurrentPage(page)
        setpayload((prv)=>({
            ...prv,
            page:page
        }))
        payload.page=page
        delete payload['distributor_id']
        setSearchParams(JSON.parse(JSON.stringify(payload)))
    };
    const handlePayload = useCallback(
        (key,value) => {
            if(key==='PRICE_RANGE'){
                setpayload((state)=>({
                    ...state,
                    PRICE_RANGE:[value.minValue,value.maxValue],
                    page:1
                }))
            }else{
                setpayload((state)=>({
                    ...state,
                    [key]:value,
                    page:1
                }))
            }
            handleToggle(key);
            if(key !=='search'){
                setInitialLoad(true);
            }
            setcurrentPage(1)
        }, [payload]);
    const handleToggle = (key)=>{
        settoggles((state)=>({
            ...state,
            [key]:!toggles[key]
        }))
    }
    const handleApply = (clear,price) => {
        let payloadCopy= {...payload}
        setInitialLoad(false)
        if(clear){
            payloadCopy={
                "page":1,
                "limit":10,
            }
            payloadCopy.category=[];
            if (payload.search) {
                payloadCopy.search = payload.search
            }
        }else{
            if(Number(priceRange.minValue) > Number(priceRange.maxValue)){
                setPriceError(true);
                return
            } else{
                setPriceError(false);
            }
            payloadCopy.PRICE_RANGE=undefined;
            if(Size?.DIAMETER !==""){
                payloadCopy.DIAMETER=Size.DIAMETER;
            }else{
                payloadCopy.DIAMETER=undefined;
            }
            if(Size?.LENGTH !==""){
                payloadCopy.LENGTH=Size.LENGTH;
            }else{
                payloadCopy.LENGTH=undefined;

            }
            if(priceRange.minValue > -1 && priceRange.maxValue > 0){
                payloadCopy.PRICE_RANGE=[priceRange.minValue,priceRange.maxValue];
            }
            if(price?.min > -1 && price?.max > 0){
                payloadCopy.PRICE_RANGE=[String(price.min),String(price.max)];
            }            
            payloadCopy.page=1
            payloadCopy.category =  FilterPayloadConstruction(result)

        }
        if(payloadCopy?.category.length ===0){
            delete payloadCopy.category
        }
        setcurrentPage(1)
        setpayload(payloadCopy);
        // const payloadCopy1 = Object.keys(payloadCopy).forEach(key => payloadCopy[key] === undefined ? delete payloadCopy[key] : {});
        delete payloadCopy['distributor_id']
        setSearchParams(JSON.parse(JSON.stringify(payloadCopy)))
        // location.search=url
        // handleFiltersData({checknoxValue:result,segments:Segments})
        setInitialLoad(true)
    }
   
    const handleCheckBox = (item,segments)=>{
        let copy =[];
        if(segments){
            copy=[...Segments]
        }else{
            copy=[...checkBox]
        }
        let keyval=item
        if(copy.includes(item)){
            keyval = item.split('.')[item.split('.').length-1];
            let parentKeyValue=item.split('.')[item.split('.').length-2]
            let idx;
            const Duplicates=[]
            copy.map((val,i)=>{
                if(val?.split('.').includes(keyval)){
                    Duplicates.push(copy.indexOf(val))
                }
            })
            if(Duplicates.length > 1){
                idx = Duplicates[Duplicates.length-1]
            }else{
                idx=copy.indexOf(item)
            }
            copy.splice(idx,1)
            const removeArr=[]
            copy.map((val)=>{
                if(!val?.split('.').includes(keyval)){
                    removeArr.push(val)
                }
            })
            let parentCount=0;
            copy.map((val)=>{
                if(val?.split('.').includes(parentKeyValue)){
                    parentCount+=1;
                }
            })
            copy=removeArr;
        }else{
            if(item.split('.').length === 0){
                copy.push(item)
            }else{
                let temp=''
                item.split('.').map((val,i)=>{
                    temp+= i===0?`${val}`:`.${val}`
                    if(!copy.includes(temp)){
                        copy.push(temp)
                    }
                });
                keyval = item.split('.')[item.split('.').length-1]
            }
            if(segments===undefined){
                findSegmnet(Filters,keyval,copy);
            }
        }
        if(segments){
            setSegments(copy)
            // handleCheckboxSegments(keyval?.split('.')[0],item,copy);

        }else{
            setcheckBox(copy)
        }

    }
    const arr=[];
    const findSegmnet = (obj,searchKey,arr)=>{
        for (var property in obj) {   
            if (obj.hasOwnProperty(property)) {
                if (Object.keys(obj[property]).length > 0 && property!=="" && property!=='concatenated_segment') {
                    if(obj[property].concatenated_segment.split('.').includes(searchKey)){
                        if(!arr.includes(obj[property].concatenated_segment)){
                            arr.push(obj[property].concatenated_segment)
                        }
                    }
                    findSegmnet(obj[property],searchKey,arr);
                }else{
                    if(obj.concatenated_segment.split('.').includes(searchKey)){
                        if(!arr.includes(obj[property].concatenated_segment)){
                            arr.push(obj[property].concatenated_segment)
                        }
                    }                
                }
            }
        }
        return arr
    }
    const handleClear = ()=>{
        setPriceError(false);
        setSegments([]);
        setSize({
            LENGTH:'',
            DIAMETER:''
        });
        setpriceRange((state)=>({
            ...state,
            maxValue:0,
            minValue:0
        }))
        if(searchParams.has("category") || searchParams.has("PRICE_RANGE") || searchParams.has("DIAMETER") || searchParams.has("LENGTH")){
            setSearchParams({search: payload.search})
            handleFetchFilters()
            handleApply('clear')
        }
        else{
            setFilterLoader(false);
            handleFetchFilters()
        }
        setcheckBox([]);
    }
    return (
        <div>
            <>{InitialLoad && Object.keys(Products).length > 0&&<><ProductListSkeleton /></>}</>
            <>{Object.keys(Products).length > 0 && !InitialLoad  ?
                <> 
                    <ProductList 
                        Products={Products.list}
                        payload={payload}
                        handleToggle={handleToggle}
                        toggles={toggles}
                        handlePayload={handlePayload}
                        setpriceRange={setpriceRange}
                        priceRange={priceRange}
                        setSize={setSize}
                        Size={Size}
                        handleApply={handleApply}
                        Filters={Filters}
                        Segments={Segments}
                        handleCheckBox={handleCheckBox}
                        checkBox={checkBox}
                        handleClear={handleClear}
                        uniqCount={uniqCount}
                        STOCK_VISIBILITY={Products.STOCK_VISIBILITY}
                        setresposivePopup={setresposivePopup}
                        resposivePopup={resposivePopup}
                        wishlistProduct={wishlistProduct}
                        handlefetch={handleFetch}
                        result={result}
                        GetCartItems={GetCartItems}
                        Cart={Cart?.items}
                        sizeList={sizeList}
                        lengthList={lengthList}
                        filterParam={filterParam}
                        filterLoader={filterLoader}
                        priceError={priceError}
                        setPriceError={setPriceError}
                    />
                    <>
                        { Products && Object.keys(Products).length > 0 && Products?.list?.length >= 1 && (
                            <div className='mb-10'>
                                <Pagination 
                                    handlePageClick={handlePageClick}
                                    List={Products}
                                    currentPage={currentPage} />
                            </div>
                        )
                        }
                    </>

                </>
                :
                <ProductListSkeleton /> }</>
        </div>
    )
}
const mapStateToProps = (state) => {
    const  { Products,FilterData,Cart } = state;
    return {Products,FilterData,Cart}

}
const mapDispatchToProps = {
    GetProductList:DistributorActions.ProductListing,
    handleSegments:DistributorActions.handleFiltersData,
    GetCartItems:DistributorActions.GetCartItems,
    handleFiltersData:DistributorActions.handleFiltersData
}
export default connect(mapStateToProps, mapDispatchToProps)(ManageProducts)
